export const ApiErrorCode = {
  EMAIL_VALIDATION: 1,
  PASSWORD_VALIDATION: 2,
  NAME_VALIDATION: 3,
  PHONE_VALIDATION: 4,
  ANONYMOUS_LIKE_LIMIT: 5,
  NEED_TO_LOGIN: 6,
  ANONYMOUS_FAVORITE_LIMIT: 7,
  EMAIL_NEEDED: 8,
} as const;

export type ApiErrorCode = (typeof ApiErrorCode)[keyof typeof ApiErrorCode];
